<template>
  <div class="product-detail-note">
    <p class="product-detail-note_title">{{ title }}</p>
    <p>
      <template v-for="(line, index) in body" :key="index">
        {{ line }}<br v-if="index < body.length - 1" />
      </template>
    </p>
    <!--
      `/set` には内容量の段落が無い（支給 `set-discount.html:336-346` は `<p>` 2つ）。
      **空文字ではなく「渡さなかったか」で判定する。** 商品詳細は `content.amount?.value ?? ''`
      を渡しており（`organisms/products/detail/index.vue:8`）、`amount` を持たない2商品では
      空文字になる。空文字で消すと商品詳細の既存の出力まで変わってしまう。
    -->
    <p v-if="amountValue !== undefined">
      <span>{{ amountLabel }}</span
      >{{ amountValue }}
    </p>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `product-detail-note`（商品詳細のリード文）。38/38 と `/set` に出る。
 * 商品詳細は全38本が `<p>` 3つの固定構成（`design-src/20260810/product-detail/product501.html:341-350`）。
 * **`/set` だけ内容量の段落を持たない**（`set-discount.html:336-346` は `<p>` 2つ）ので、
 * `amountValue` を渡さなければ3段落目ごと出ない。空文字を渡した場合は従来どおりラベルだけ出る。
 *
 * **出どころが3系統に分かれる。**
 * - `title` … API の `topCatchphrase`（38/38 で値がある）
 * - `body` … API の `description` ＋ `annotation`。**`description` は 22/38 でしか返らない**ため、
 *   スキンケア4本とパーソナルケア12本（`NS1` `NS2` `NS3` `NST` `K41`〜`K45` `KF01` `KF02` `KF03`
 *   `KF05` `KF15` `KG01` `KG02`）は商品別 const から渡す。`annotation` は `525` の
 *   「※対象年齢6歳以上」だけが値を持ち、支給も本文末尾に置いている
 *   （`productContents/<商品コード>/annotation.vue` は0本で、現状この値は本番に出ていない）
 * - `amountLabel` / `amountValue` … 既存 `productContents/<商品コード>/referenceAmount.vue` 由来の商品別 const
 *
 * **`body` は行の配列**（決定#56）。支給の `<br>` を要素の区切りで表す。装飾タグは支給に無いので
 * `v-html` は使わない。
 *
 * `amountLabel` は支給の実測で **`内容量` 35本 ／ `パッケージ内容` 3本**。既定は `内容量`。
 * → CONVERSION-GUIDE.md §3.3.1 の #3
 */
type Props = {
  /** 見出し。API の `topCatchphrase` */
  title: string;
  /** 本文。1要素＝1行（支給の `<br>` 区切り）。API の `description` ＋ `annotation` */
  body: string[];
  /** 3段落目のラベル。支給は `内容量` か `パッケージ内容` */
  amountLabel?: string;
  /**
   * 3段落目の値。既存 `referenceAmount.vue` 由来。
   * **渡さなければ3段落目ごと出ない**（`/set` 用）。空文字を渡した場合はラベルだけ出る
   * （商品詳細の既存の挙動を変えないため）。
   */
  amountValue?: string;
};

withDefaults(defineProps<Props>(), {
  amountLabel: '内容量',
});
</script>
